import * as React from 'react';
import { cn } from './cn';

interface CheckboxProps
	extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> {
	label?: React.ReactNode;
	description?: string;
	error?: string;
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
	({ label, description, error, className, id, ...rest }, ref) => {
		const reactId = React.useId();
		const inputId = id || `cb-${reactId}`;
		return (
			<label htmlFor={inputId} className={cn('flex items-start gap-2.5 cursor-pointer', className)}>
				<input
					ref={ref}
					id={inputId}
					type="checkbox"
					className={cn(
						'mt-0.5 h-4 w-4 rounded border-slate-300 text-brand-700',
						'focus:ring-2 focus:ring-brand-500 focus:ring-offset-0',
						error && 'border-danger-400'
					)}
					{...rest}
				/>
				{(label || description) && (
					<span className="text-sm leading-tight">
						{label && <span className="text-ink font-medium">{label}</span>}
						{description && (
							<span className="block text-ink-muted text-xs">
								{description}
							</span>
						)}
					</span>
				)}
			</label>
		);
	}
);
Checkbox.displayName = 'Checkbox';

export default Checkbox;
